import { InputLabel } from "@mui/material";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Etiqueta y texto de ayuda con el formato de los formularios del dashboard.
export default function Campo({ id, label, requerido, ayuda, error, children }) {
  return (
    <SoftBox>
      <InputLabel htmlFor={id}>
        <SoftTypography component="span" variant="caption" fontWeight="bold">
          {label}
          {requerido && <SoftTypography variant="caption" fontWeight="bold" color="primary">&nbsp;*</SoftTypography>}
        </SoftTypography>
      </InputLabel>
      {children}
      {(error || ayuda) && (
        <SoftTypography variant="caption" display="block" mt={0.5} color={error ? "error" : "secondary"}>
          {error || ayuda}
        </SoftTypography>
      )}
    </SoftBox>
  );
}

Campo.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node.isRequired,
  requerido: PropTypes.bool,
  ayuda: PropTypes.node,
  error: PropTypes.node,
  children: PropTypes.node.isRequired,
};
